import { createSignal, type JSX } from 'solid-js';
import { t } from '../i18n';
import { copyText } from '../lib/clipboard';
import { Button } from './ui/Button';

// The run id, with a way to take it with you. It was bare text in a <code>, and
// a run id is the one string a reader needs verbatim — to paste into `box`
// tooling, an issue, a psql query or a support thread — from a 32-hex token
// nobody retypes correctly.
//
// Goes through `copyText` (`lib/clipboard.ts`) rather than
// `void navigator.clipboard?.writeText(x)`: on a non-secure context the `?.`
// swallows the absent clipboard and a rejected write escapes as a floating
// promise, both of which read as "the click did nothing". A write that did not
// land must not report "Copied".

export type RunIdBadgeProps = {
  readonly runId: string;
};

export function RunIdBadge(props: RunIdBadgeProps): JSX.Element {
  const [copied, setCopied] = createSignal(false);
  const copy = async (): Promise<void> => {
    setCopied(await copyText(props.runId));
  };
  return (
    <span class="audit-id">
      {t('fleet.run_label')} <code>{props.runId}</code>{' '}
      <Button
        variant="ghost"
        size="sm"
        onClick={() => {
          void copy();
        }}
      >
        {copied() ? t('fleet.run_id_copied') : t('fleet.copy_run_id')}
      </Button>
    </span>
  );
}
